import fetch from '@/utils/fetch';
import {systemFetch} from '@/utils/fetch';
//膳食营养-详情
export function dietaryElementSet() {
    return fetch({
      url: 'structure/dietary/dietaryElementSet',
      method: 'get'
    });
  }
//膳食营养-新增
export function insertDietaryElementSet(args) {
  return fetch({
      headers: {
          'content-type': 'application/json'
      },
      url: 'structure/dietary/insertDietaryElementSet',
      method: 'POST',
      data: JSON.stringify(args)
  });
}
//膳食营养-类型设置量-详情
export function foodTypeSet() {
  return fetch({
    url: 'structure/dietary/foodTypeSet',
    method: 'get'
  });
}
//膳食营养-类型设置量-新增
export function saveFoodTypeSet(args) {
  return fetch({
      headers: {
          'content-type': 'application/json'
      },
      url: 'structure/dietary/saveFoodTypeSet',
      method: 'POST',
      data: JSON.stringify(args)
  });
}
//专家食谱列表
export function publicMenuList() {
  let params = new URLSearchParams();
  return fetch({
      url: 'structure/dietary/publicMenuList?isShow=0',
      method: 'get'
  });
}
//专家食谱的详情
export function publicMenuDetails(menuId) {
  let params = new URLSearchParams();
  params.append('menuId', menuId);
  return fetch({
      url: 'structure/dietary/publicMenuDetails',
      method: 'get',
      params
  });
}
//删除食谱
export function deletePublicMenu(menuId) {
  let params = new URLSearchParams();
  params.append('menuId', menuId);
  return fetch({
      url: 'structure/dietary/deletePublicMenu',
      method: 'get',
      params
  });
}
//发布食谱
export function showPublicMenu(menuId) {
  let params = new URLSearchParams();
  params.append('menuId', menuId);
  return fetch({
      url: 'structure/dietary/showPublicMenu',
      method: 'get',
      params
  });
}
//选择食材
export function chooseSchoolFood(searchName,typeId) {
  let params = new URLSearchParams();
  params.append('searchName', searchName);
  params.append('typeId', typeId);
  return fetch({
      url: 'structure/dietary/chooseFood',
      method: 'get',
      params
  });
}
//新增食谱
export function insertPublicMenu(listQuery) {
  let params = new URLSearchParams();
  params.append('fridayFoodIds', listQuery.fridayFoodIds);
  params.append('mondayFoodIds', listQuery.mondayFoodIds);
  params.append('name', listQuery.name);
  params.append('saturdayFoodIds', listQuery.saturdayFoodIds);
  params.append('showMenu', listQuery.showMenu);
  params.append('sundayFoodIds', listQuery.sundayFoodIds);
  params.append('thursdayFoodIds', listQuery.thursdayFoodIds);
  params.append('tuesdayFoodIds', listQuery.tuesdayFoodIds);
  params.append('wednesdayFoodIds', listQuery.wednesdayFoodIds);
  return fetch({
      url: 'structure/dietary/insertPublicMenu',
      method: 'post',
      data: params
  });
}
//编辑食谱
export function updatePublicMenu(listQuery) {
  let params = new URLSearchParams();
  params.append('fridayFoodIds', listQuery.fridayFoodIds);
  params.append('mondayFoodIds', listQuery.mondayFoodIds);
  params.append('name', listQuery.name);
  params.append('saturdayFoodIds', listQuery.saturdayFoodIds);
  params.append('showMenu', listQuery.showMenu);
  params.append('sundayFoodIds', listQuery.sundayFoodIds);
  params.append('thursdayFoodIds', listQuery.thursdayFoodIds);
  params.append('tuesdayFoodIds', listQuery.tuesdayFoodIds);
  params.append('wednesdayFoodIds', listQuery.wednesdayFoodIds);
  params.append('id', listQuery.id);
  return fetch({
      url: 'structure/dietary/updatePublicMenu',
      method: 'post',
      data: params
  });
}
//根据字典code获得字典数据
export function findDicsByCode(dicCode){
  let params = new URLSearchParams();
  params.append('dicCode', dicCode);
  return fetch({
      url: 'structure/sysDictionary/findDicsByCode',
      method: 'post',
      data: params
  });
}
//分页获取系统食谱
export function queryFoodList(listQuery) {
  let params = new URLSearchParams();
  params.append('pageNo', listQuery.pageNo);
  params.append('pageSize', listQuery.pageSize);
  params.append('searchName', listQuery.searchName);
  params.append('typeId', listQuery.typeId);
  return fetch({
      url: 'structure/dietary/queryFoodList',
      method: 'post',
      data: params
  });
}
//删除食物
export function deleteFood(ids) {
  let params = new URLSearchParams();
  params.append('ids', ids);
  return fetch({
      url: 'structure/dietary/deleteFood',
      method: 'get',
      params
  });
}
//食物详情
export function foodDetails(id) {
  let params = new URLSearchParams();
  params.append('id', id);
  return fetch({
      url: 'structure/dietary/foodDetails',
      method: 'get',
      params
  });
}
//选择食材
export function chooseMaterial(searchName,typeId) {
  let params = new URLSearchParams();
  params.append('searchName', searchName);
  params.append('typeId', typeId);
  return fetch({
      url: 'structure/dietary/chooseMaterial',
      method: 'get',
      params
  });
}
//新增食物
export function insertFood(listQuery) {
  let params = new URLSearchParams();
  params.append('materialJson', listQuery.materialJson);
  params.append('methodId', listQuery.methodId);
  params.append('methodName', listQuery.methodName);
  params.append('name', listQuery.name);
  params.append('pic', listQuery.pic);
  params.append('publicFood', listQuery.publicFood);
  params.append('remark', listQuery.remark);
  params.append('schoolId', listQuery.schoolId);
  params.append('typeId', listQuery.typeId);
  params.append('typeName', listQuery.typeName);
  return fetch({
      url: 'structure/dietary/insertFood',
      method: 'post',
      data: params
  });
}
//编辑食物
export function updateFood(listQuery) {
  let params = new URLSearchParams();
  params.append('id', listQuery.id);
  params.append('materialJson', listQuery.materialJson);
  params.append('methodId', listQuery.methodId);
  params.append('methodName', listQuery.methodName);
  params.append('name', listQuery.name);
  params.append('pic', listQuery.pic);
  params.append('publicFood', listQuery.publicFood);
  params.append('remark', listQuery.remark);
  params.append('schoolId', listQuery.schoolId);
  params.append('typeId', listQuery.typeId);
  params.append('typeName', listQuery.typeName);
  return fetch({
      url: 'structure/dietary/updateFood',
      method: 'post',
      data: params
  });
}
//分页获取学校食谱
export function queryUnPublishedFood(listQuery) {
  let params = new URLSearchParams();
  params.append('pageNo', listQuery.pageNo);
  params.append('pageSize', listQuery.pageSize);
  params.append('searchName', listQuery.searchName);
  params.append('typeId', listQuery.typeId);
  return fetch({
      url: 'structure/dietary/queryUnPublishedFood',
      method: 'post',
      data: params
  });
}
//把食物设成系统食物
export function publishFood(foodId) {
  let params = new URLSearchParams();
  params.append('foodId', foodId);
  return fetch({
      url: 'structure/dietary/publishFood',
      method: 'get',
      params
  });
}
//分页获取食材，typeId=0时获取全部
export function queryMaterialLst(listQuery) {
  let params = new URLSearchParams();
  params.append('pageNo', listQuery.pageNo);
  params.append('pageSize', listQuery.pageSize);
  params.append('searchName', listQuery.searchName);
  params.append('typeId', listQuery.typeId);
  return fetch({
      url: 'structure/dietary/queryMaterialLst',
      method: 'post',
      data: params
  });
}
//删除食材
export function deleteMaterial(ids) {
  let params = new URLSearchParams();
  params.append('ids', ids);
  return fetch({
      url: 'structure/dietary/deleteMaterial',
      method: 'get',
      params
  });
}
//食材详情
export function materialDetails(id) {
  let params = new URLSearchParams();
  params.append('id', id);
  return fetch({
      url: 'structure/dietary/materialDetails',
      method: 'get',
      params
  });
}
//新增食材
export function insertMaterial(listQuery) {
  let params = new URLSearchParams();
  params.append('ca', listQuery.ca);
  params.append('carbohydrate', listQuery.carbohydrate);
  params.append('energy', listQuery.energy);
  params.append('fat', listQuery.fat);
  params.append('fe', listQuery.fe);
  params.append('foodPart', listQuery.foodPart);
  params.append('name', listQuery.name);
  params.append('pic', listQuery.pic);
  params.append('protein', listQuery.protein);
  params.append('typeId', listQuery.typeId);
  params.append('typeName', listQuery.typeName);
  params.append('vitaminA', listQuery.vitaminA);
  params.append('vitaminB1', listQuery.vitaminB1);
  params.append('vitaminB2', listQuery.vitaminB2);
  params.append('vitaminC', listQuery.vitaminC);
  params.append('vitaminE', listQuery.vitaminE);
  params.append('zn', listQuery.zn);
  return fetch({
      url: 'structure/dietary/insertMaterial',
      method: 'post',
      data: params
  });
}
//编辑食材
export function updateMaterial(listQuery) {
  let params = new URLSearchParams();
  params.append('ca', listQuery.ca);
  params.append('carbohydrate', listQuery.carbohydrate);
  params.append('energy', listQuery.energy);
  params.append('fat', listQuery.fat);
  params.append('fe', listQuery.fe);
  params.append('foodPart', listQuery.foodPart);
  params.append('name', listQuery.name);
  params.append('pic', listQuery.pic);
  params.append('protein', listQuery.protein);
  params.append('typeId', listQuery.typeId);
  params.append('typeName', listQuery.typeName);
  params.append('vitaminA', listQuery.vitaminA);
  params.append('vitaminB1', listQuery.vitaminB1);
  params.append('vitaminB2', listQuery.vitaminB2);
  params.append('vitaminC', listQuery.vitaminC);
  params.append('vitaminE', listQuery.vitaminE);
  params.append('zn', listQuery.zn);
  params.append('id', listQuery.id);
  return fetch({
      url: 'structure/dietary/updateMaterial',
      method: 'post',
      data: params
  });
}

//分页获取公共菜品列表
export function dietCommonList(listQuery) {
  let params = new URLSearchParams();
  params.append('pageNo', listQuery.pageNo);
  params.append('pageSize', listQuery.pageSize);
  params.append('searchName', listQuery.searchName);
  return fetch({
      url: 'structure/diet/queryCommonDietList',
      method: 'post',
      data: params
  });
}
//管理员删除公共菜品
export function deleteDietCommon(dietCommonIds) {
  let params = new URLSearchParams();
  params.append('dietCommonIds', dietCommonIds);
  return fetch({
      url: 'structure/diet/deleteCommonDiet',
      method: 'get',
      params
  });
}
//微研管理员查看学校菜品库
export function allSchoolDietList(listQuery) {
  let params = new URLSearchParams();
  params.append('pageNo', listQuery.pageNo);
  params.append('pageSize', listQuery.pageSize);
  params.append('searchName', listQuery.searchName);
  return fetch({
      url: 'structure/diet/allSchoolDietList',
      method: 'post',
      data: params
  });
}
//管理员把学校菜品批量添加到公共菜品
export function batchInsertDietCommon(dietSchoolIds) {
  let params = new URLSearchParams();
  params.append('dietSchoolIds', dietSchoolIds);
  return fetch({
      url: 'structure/diet/batchInsertCommonDiet',
      method: 'get',
      params
  });
}
//管理员添加菜品
export function insertDietCommon(listQuery) {
  let params = new URLSearchParams();
  params.append('dietDes', listQuery.dietDes);
  params.append('dietLogo', listQuery.dietLogo);
  params.append('dietName', listQuery.dietName);
  params.append('dietType', listQuery.dietType);
  params.append('dietTypeName', listQuery.dietTypeName);
  return fetch({
      url: 'structure/diet/insertCommonDiet',
      method: 'post',
      data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/foodSetting.js